$(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/tulkin-opas-kiitos/"
    };

    $("#interpretersGuideSendBtn").on("click", function(event) {
        if ($('#interpretersGuideForm')[0].checkValidity() && $('#interpretersGuideCheckbox').is(':checked')) {
            $("#interpretersGuideSendBtn").prop("disabled", true);
            $("#interpretersGuideSendBtn").css("background-color", "#6c757d");
        
            let email = $("#interpretersGuideEmail").val();
            let firstName = $("#interpretersGuideFirstName").val();
            let lastName = $("#interpretersGuideLastName").val();
            let selectedOccupation = $("input[name='occupation']:checked").val();
            let code = "";

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                additionalInformation: selectedOccupation,
                competitionName: "Interpreters guide",
                uri: "/fi/tulkin-opas/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function() {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function(err) {
                    console.error(err);
                    $("#interpretersGuideSendBtn").prop("disabled", false);
                    $("#interpretersGuideSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#interpretersGuideForm')[0].checkValidity();
        const checkboxChecked = $('#interpretersGuideCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            $("#interpretersGuideSendBtn").prop("disabled", false);
            $("#interpretersGuideSendBtn").css("background-color", "#28a745");
        } else {
            $("#interpretersGuideSendBtn").prop("disabled", true);
            $("#interpretersGuideSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    $('#interpretersGuideForm input, #interpretersGuideCheckbox').on('input change', toggleSendButtonState);

    // Initial button state check
    toggleSendButtonState();
});
